import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import { Router } from '@angular/router';
import { ShuttelbussService } from '../../../../../../services/shuttlebuss.service';
import { SnackbarService } from '../../../../../../services/snackbar.service';
import { BackOfficeService } from '../../../../../../services/backoffice.service';

@Component({
  selector: 'app-back-office24-travel-agency-bottomsheet',
  templateUrl: './back-office24-travel-agency-bottomsheet.component.html',
  styleUrl: './back-office24-travel-agency-bottomsheet.component.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BackOffice24TravelAgencyBottomsheetComponent implements OnInit {
  isLoading = false;

  constructor(
    @Inject(MAT_BOTTOM_SHEET_DATA) public userInput: any,
    public shuttleBussService: ShuttelbussService,
    public backOfficeService: BackOfficeService,
    private bottomSheetRef: MatBottomSheetRef<BackOffice24TravelAgencyBottomsheetComponent>,
    public router: Router,
    public snackbar: SnackbarService
  ) { }

  ngOnInit(): void {
  }

  reset(): void {
    this.shuttleBussService.resetForm();
  }

  cancel() {
    this.bottomSheetRef.dismiss();
  }

  sendConfirmation() {
    this.isLoading = true;
    this.backOfficeService.setOrderStatusPaidCart(this.userInput.cart.orderId, '').subscribe(result => {
      this.bottomSheetRef.dismiss({
        customer: this.userInput.customer,
        cart: this.userInput.cart
      });
      this.isLoading = false;
      this.snackbar.openSnackBar('Order Status Paid', 'OK');
      this.reset();
    });
  }
}
